// Module
var code = "You should return to the bridge/waterfront, press ‘I’m there’ when you are. ";
// Exports
module.exports = code;